import { motion } from "framer-motion";
import { useState } from "react";
import ScrollReveal from "./scroll-reveal";

export default function ContactSection() {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    subject: "",
    message: "",
  });

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    // Handle form submission
    console.log("Form submitted:", formData);
  };

  const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  return (
    <section id="contact" className="py-20 bg-primary dark:bg-gray-900 text-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <ScrollReveal>
          <div className="text-center mb-16">
            <h2 className="text-4xl md:text-5xl font-playfair font-bold mb-4">
              Get In Touch
            </h2>
            <p className="text-xl max-w-2xl mx-auto">
              Ready to transform your workspace? Let's discuss your furniture needs
            </p>
          </div>
        </ScrollReveal>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12">
          {/* Contact Information */}
          <ScrollReveal>
            <div className="glass-effect rounded-2xl p-8 backdrop-blur-sm">
              <h3 className="text-2xl font-semibold mb-6">Contact Information</h3>
              
              <div className="space-y-6">
                <motion.div
                  className="flex items-start space-x-4"
                  whileHover={{ x: 10 }}
                  transition={{ duration: 0.2 }}
                >
                  <div className="bg-accent rounded-full p-3 flex-shrink-0">
                    <i className="fas fa-user text-white"></i>
                  </div>
                  <div>
                    <h4 className="font-semibold">Harsh Vora</h4>
                    <p className="text-gray-300">Director, KASA Furniture</p>
                  </div>
                </motion.div>
                
                <motion.div
                  className="flex items-start space-x-4"
                  whileHover={{ x: 10 }}
                  transition={{ duration: 0.2 }}
                >
                  <div className="bg-accent rounded-full p-3 flex-shrink-0">
                    <i className="fas fa-map-marker-alt text-white"></i>
                  </div>
                  <div>
                    <h4 className="font-semibold">Address</h4>
                    <p className="text-gray-300">
                      FF/1, Shaastra Complex, Opp Drive-In Cinema,<br />
                      Nr Aashvi Hospital, Bodakdev,<br />
                      Ahmedabad, Gujarat, India – 380054
                    </p>
                  </div>
                </motion.div>
                
                <motion.div
                  className="flex items-start space-x-4"
                  whileHover={{ x: 10 }}
                  transition={{ duration: 0.2 }}
                >
                  <div className="bg-accent rounded-full p-3 flex-shrink-0">
                    <i className="fas fa-phone text-white"></i>
                  </div>
                  <div>
                    <h4 className="font-semibold">Phone</h4>
                    <p className="text-gray-300">+91 9512170618</p>
                  </div>
                </motion.div>
                
                <motion.div
                  className="flex items-start space-x-4"
                  whileHover={{ x: 10 }}
                  transition={{ duration: 0.2 }}
                >
                  <div className="bg-accent rounded-full p-3 flex-shrink-0">
                    <i className="fas fa-envelope text-white"></i>
                  </div>
                  <div>
                    <h4 className="font-semibold">Email</h4>
                    <p className="text-gray-300">harshvora@kasafurniture.co.in</p>
                  </div>
                </motion.div>
                
                <motion.div
                  className="flex items-start space-x-4"
                  whileHover={{ x: 10 }}
                  transition={{ duration: 0.2 }}
                >
                  <div className="bg-accent rounded-full p-3 flex-shrink-0">
                    <i className="fas fa-globe text-white"></i>
                  </div>
                  <div>
                    <h4 className="font-semibold">Website</h4>
                    <p className="text-gray-300">www.kasafurniture.co.in</p>
                  </div>
                </motion.div>
                
                <motion.div
                  className="flex items-start space-x-4"
                  whileHover={{ x: 10 }}
                  transition={{ duration: 0.2 }}
                >
                  <div className="bg-accent rounded-full p-3 flex-shrink-0">
                    <i className="fab fa-instagram text-white"></i>
                  </div>
                  <div>
                    <h4 className="font-semibold">Instagram</h4>
                    <p className="text-gray-300">@kasa.furniture</p>
                  </div>
                </motion.div>
              </div>
            </div>
          </ScrollReveal>
          
          {/* Contact Form */}
          <ScrollReveal delay={0.3}>
            <div className="glass-effect rounded-2xl p-8 backdrop-blur-sm">
              <h3 className="text-2xl font-semibold mb-6">Send us a Message</h3>
              
              <form onSubmit={handleSubmit} className="space-y-6">
                <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                  <motion.div whileFocus={{ scale: 1.02 }}>
                    <input
                      type="text"
                      name="name"
                      placeholder="Your Name"
                      value={formData.name}
                      onChange={handleChange}
                      className="w-full px-4 py-3 bg-white bg-opacity-20 border border-white border-opacity-30 rounded-lg focus:outline-none focus:ring-2 focus:ring-accent text-white placeholder-gray-300 hover-cursor"
                      required
                    />
                  </motion.div>
                  <motion.div whileFocus={{ scale: 1.02 }}>
                    <input
                      type="email"
                      name="email"
                      placeholder="Your Email"
                      value={formData.email}
                      onChange={handleChange}
                      className="w-full px-4 py-3 bg-white bg-opacity-20 border border-white border-opacity-30 rounded-lg focus:outline-none focus:ring-2 focus:ring-accent text-white placeholder-gray-300 hover-cursor"
                      required
                    />
                  </motion.div>
                </div>
                
                <motion.div whileFocus={{ scale: 1.02 }}>
                  <input
                    type="text"
                    name="subject"
                    placeholder="Subject"
                    value={formData.subject}
                    onChange={handleChange}
                    className="w-full px-4 py-3 bg-white bg-opacity-20 border border-white border-opacity-30 rounded-lg focus:outline-none focus:ring-2 focus:ring-accent text-white placeholder-gray-300 hover-cursor"
                    required
                  />
                </motion.div>
                
                <motion.div whileFocus={{ scale: 1.02 }}>
                  <textarea
                    name="message"
                    rows={5}
                    placeholder="Your Message"
                    value={formData.message}
                    onChange={handleChange}
                    className="w-full px-4 py-3 bg-white bg-opacity-20 border border-white border-opacity-30 rounded-lg focus:outline-none focus:ring-2 focus:ring-accent text-white placeholder-gray-300 resize-none hover-cursor"
                    required
                  />
                </motion.div>
                
                <motion.button
                  type="submit"
                  className="w-full bg-accent hover:bg-opacity-90 text-white py-3 rounded-lg font-semibold transition-all duration-300 hover-lift hover-cursor"
                  whileHover={{ scale: 1.02 }}
                  whileTap={{ scale: 0.98 }}
                >
                  Send Message
                </motion.button>
              </form>
            </div>
          </ScrollReveal>
        </div>
      </div>
    </section>
  );
}
